// # the green pill tag

interface SpecialityBadgeProps {
  label: string;
}

const SpecialityBadge: React.FC<SpecialityBadgeProps> = ({ label }) => (
  <span className="text-theme-brand-blue border-theme-success-2 bg-theme-success-opac rounded-full border px-2 py-1.25 text-[10px] font-bold">
    {label}
  </span>
);

export default SpecialityBadge;
